import { all, put, takeEvery, takeLatest } from 'redux-saga/effects';
import actions from './actions';
import * as _ from 'lodash';
import { push } from 'react-router-redux';
import history from '../../../../src/helpers/auth0/history';
import { SERVER_ERRORS } from '../../../api/SERVER_ERRORS';
import { clearToken } from '../../../helpers/utility';

function* showNotification({payload}) {
    if (payload.code && payload.code !== SERVER_ERRORS.UNKNOWN_SERVER_ERROR && !_.findKey(SERVER_ERRORS, (e) => e === payload.code)) payload.code = undefined;

    if (!payload.code && (!payload.message || payload.message === "")) payload.code = SERVER_ERRORS.UNKNOWN_SERVER_ERROR;
    
    yield all([
        payload.mainAction ? put({ type: payload.mainAction, ...payload.obj }) : "",
        put({ type: actions.SHOW_NOTIFICATION, status: payload.status || "ERROR", code: payload.code, message: payload.message, duration: payload.duration })
    ]);
}

function* logoutOnSessionExpire({payload}) {
    if (payload.code && payload.code === SERVER_ERRORS.INVALID_TOKEN)
    {
        clearToken();
        history.replace('/');
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.CREATE_NOTIFICATION, showNotification),
        takeLatest(actions.CREATE_NOTIFICATION, logoutOnSessionExpire),
    ]);
}
